// extracted by mini-css-extract-plugin
export default {"mobile_title":"resources_mobile_title__GkDoi","category_links_wrapper":"resources_category_links_wrapper__-+9Qo"};